














import { Component, Vue } from "@/shared/node_modules/vue-property-decorator";
import CzMenu from "../menu/czmenu.vue";
import Footer from "@/shared/components/footer/footer.vue";
import store from "@/shared/core/store";

@Component({
  components: {
    CzMenu,
    Footer,
  },
})
export default class InSecure extends Vue {
  created() {}

  async mounted() {
    const shared = store.state.settings;
    if (shared.ButtonsColor !== null && shared.ButtonsColor !== undefined) {
      document.documentElement.style.setProperty(
        "--main-color",
        shared.ButtonsColor
      );
    }
    this.setBrandTints(shared.ButtonsColor);
    if (shared.FontFamily !== null && shared.FontFamily !== undefined) {
      document.documentElement.style.setProperty(
        "--main-family",
        shared.FontFamily
      );
    }

    if (shared.FooterColor !== null && shared.FooterColor !== undefined) {
      document.documentElement.style.setProperty(
        "--main-footercolor",
        shared.FooterColor
      );
    }

    const logo = shared.Uploads + "/" + shared.Mainlogo;
    var link: any = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = logo;
  }

  setBrandTints(color: string | null | undefined) {
    const root = document.documentElement;
    const computed = getComputedStyle(root).getPropertyValue("--main-color");
    const base = (color || computed || "").trim();
    const rgb = this.hexToRgb(base);
    if (!rgb) {
      if (base) {
        root.style.setProperty("--brand-strong", base);
      }
      root.style.setProperty("--brand-deep", "#2d2244");
      return;
    }

    const soft = this.mixWithWhite(rgb, 0.75);
    const softer = this.mixWithWhite(rgb, 0.88);

    root.style.setProperty("--brand-strong", this.rgbToHex(rgb));
    root.style.setProperty("--brand-soft", this.rgbToHex(soft));
    root.style.setProperty("--brand-softer", this.rgbToHex(softer));
    root.style.setProperty("--brand-deep", this.rgbToHex(this.deepen(rgb)));
  }

  // The tenant color darkened until white text on it reads at 4.5:1.
  deepen(rgb: { r: number; g: number; b: number }) {
    let color = rgb;
    while (this.contrastWithWhite(color) < 4.5) {
      color = { r: Math.floor(color.r * 0.92), g: Math.floor(color.g * 0.92), b: Math.floor(color.b * 0.92) };
    }
    return color;
  }

  contrastWithWhite({ r, g, b }: { r: number; g: number; b: number }) {
    const linear = (channel: number) => {
      const c = channel / 255;
      return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
    };
    const luminance = 0.2126 * linear(r) + 0.7152 * linear(g) + 0.0722 * linear(b);
    return 1.05 / (luminance + 0.05);
  }

  hexToRgb(hex: string) {
    if (!hex) return null;
    let value = hex.trim();
    if (value.startsWith("rgb")) {
      const match = value.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/i);
      if (!match) return null;
      return {
        r: Number(match[1]),
        g: Number(match[2]),
        b: Number(match[3]),
      };
    }
    if (value[0] === "#") value = value.slice(1);
    if (value.length === 3) {
      value = value
        .split("")
        .map((ch) => ch + ch)
        .join("");
    }
    if (value.length !== 6) return null;
    const num = parseInt(value, 16);
    if (Number.isNaN(num)) return null;
    return {
      r: (num >> 16) & 255,
      g: (num >> 8) & 255,
      b: num & 255,
    };
  }

  rgbToHex({ r, g, b }: { r: number; g: number; b: number }) {
    const toHex = (n: number) => n.toString(16).padStart(2, "0");
    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
  }

  mixWithWhite(
    { r, g, b }: { r: number; g: number; b: number },
    ratio: number
  ) {
    const mix = (channel: number) =>
      Math.round(channel + (255 - channel) * ratio);
    return { r: mix(r), g: mix(g), b: mix(b) };
  }
}
